import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Office } from 'src/app/Models/office';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-office',
  templateUrl: './office.component.html',
  styleUrls: ['./office.component.css']
})
export class OfficeComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Office;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Office form';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });

  }

  save(addNew: boolean): void {

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateOffice(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Office information updated Successfully...", "");

	this.logtext = 'Update & Close - Office form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Office ]";
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Office form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Office ]";
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });

              this.message.error("Failed to update office information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createOffice(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Office information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Office form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Office ]";
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });
	}

              else {
                this.data = new Office();
	this.logtext = 'Save & New - Office form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Office ]";
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add office information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Office form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Office ]";
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });
              
            }
          });
      }
  }


}